export class PharmacyItem {
    Id: number;
    ItemId: number ;
    Title: string;
    ForeignTitle: string;
    ItemCode: string;
    TypeId: number = 0;
}
